
const usePanelCurrentMember = () => {
    const gender = (type) =>{
        let gender = type||'-'
        switch (type) {
            case 'M':
                gender='Male'
                break;
            case 'F':
                gender='Female'
                break;
            default:
                break;
        }
        return gender
    }
    const columns = [
        { field: 'email', headerName: 'Email', width: 200 },
        { field: 'title', headerName: 'Title', width: 100 },
        { field: 'surname', headerName: 'Surname', width: 140 },
        {
            field: 'firstName',
            headerName: 'First Name',
            width: 140,
        },
        { field: 'gender', headerName: 'Gender', width: 100, valueGetter: (params) => gender(params.value) },
        { field: 'department', headerName: 'Department', width: 140 },
        { field: 'post', headerName: 'Post', width: 100 },
    ];

    return { columns };
};

export default usePanelCurrentMember;
